import {createAction, props} from '@ngrx/store';
import {Update} from '@ngrx/entity';

import {UpdateCitizenPassword} from './update-citizen-password.model';

export const loadUpdateCitizenPasswords = createAction(
  '[UpdateCitizenPassword/API] Load UpdateCitizenPasswords',
  props<{ updateCitizenPasswords: UpdateCitizenPassword[] }>()
);

export const addUpdateCitizenPassword = createAction(
  '[UpdateCitizenPassword/API] Add UpdateCitizenPassword',
  props<{ updateCitizenPassword: UpdateCitizenPassword }>()
);

export const upsertUpdateCitizenPassword = createAction(
  '[UpdateCitizenPassword/API] Upsert UpdateCitizenPassword',
  props<{ updateCitizenPassword: UpdateCitizenPassword }>()
);

export const addUpdateCitizenPasswords = createAction(
  '[UpdateCitizenPassword/API] Add UpdateCitizenPasswords',
  props<{ updateCitizenPasswords: UpdateCitizenPassword[] }>()
);

export const upsertUpdateCitizenPasswords = createAction(
  '[UpdateCitizenPassword/API] Upsert UpdateCitizenPasswords',
  props<{ updateCitizenPasswords: UpdateCitizenPassword[] }>()
);

export const updateUpdateCitizenPassword = createAction(
  '[UpdateCitizenPassword/API] Update UpdateCitizenPassword',
  props<{ updateCitizenPassword: Update<UpdateCitizenPassword> }>()
);

export const updateUpdateCitizenPasswords = createAction(
  '[UpdateCitizenPassword/API] Update UpdateCitizenPasswords',
  props<{ updateCitizenPasswords: Update<UpdateCitizenPassword>[] }>()
);

export const deleteUpdateCitizenPassword = createAction(
  '[UpdateCitizenPassword/API] Delete UpdateCitizenPassword',
  props<{ id: string }>()
);

export const deleteUpdateCitizenPasswords = createAction(
  '[UpdateCitizenPassword/API] Delete UpdateCitizenPasswords',
  props<{ ids: string[] }>()
);

export const clearUpdateCitizenPasswords = createAction(
  '[UpdateCitizenPassword/API] Clear UpdateCitizenPasswords'
);


//CUSTOM

export const updateCitizenPassword = createAction(
  '[UpdateCitizenPassword/API] update Citizen Password',
  props<{ citizenUniqueId?: string,userPassword?:string }>()
);


